import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { IconChevronDown } from '@calendly/ui/components/glyphs/IconChevronDown';
import { IconChevronRight } from '@calendly/ui/components/glyphs/IconChevronRight';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { useMemo } from 'react';
import { stripHtmlTags } from 'features/scoped_url_state';
import { CallieCopyPromptButton } from './copy_prompt_button';
import { parseCalliePromptHtml } from './prompt_variable';
const capabilitiesCss = "c16esbud";
const capabilitySectionCss = "c1eviio9";
const capabilityHeaderCss = "c3p2nwx";
const capabilityHeaderCopyCss = "c1xykcrr";
const capabilityToggleCss = "c1tzg5vr";
const capabilityContentCss = "cit3dqn";
const exampleSlotCss = "ez26ui4";
const exampleRowCss = "e1nbu3s9";
const promptSentenceCss = "pi8bb70";

/*
 * Practice email CTA layout — restore with the button below once the practice-email endpoint is implemented.
const exampleActionsCss = css`
  display: flex;
  justify-content: flex-end;
`
*/

const CapabilityExample = ({
  copySource,
  exampleLabel,
  examplePrompt
}) => <>
    <div className={exampleSlotCss}>
      <BodyText color="muted" size="small">
        {exampleLabel}
      </BodyText>
      <div className={exampleRowCss}>
        <div className={promptSentenceCss}>
          {parseCalliePromptHtml(examplePrompt)}
        </div>
        <CallieCopyPromptButton content={stripHtmlTags(copySource ?? examplePrompt)} />
      </div>
    </div>
    {/*
      Practice email CTA — restore with exampleActionsCss above once the practice-email endpoint is implemented.
      Also restore: Button, IconSend, UiIcon imports.
       <div className={exampleActionsCss}>
        <Button
          data-testid="callie-practice-email-button"
          appearance="secondary-outline"
          size="small"
        >
          <UiIcon icon={IconSend} size="small" />
          {I18n.t('publisher.home.scheduling_subsection.callie.card.practice_email_cta')}
        </Button>
      </div>
     */}
  </>;
const CapabilitySection = ({
  section,
  isExpanded,
  onToggle
}) => {
  const {
    description,
    exampleLabel,
    examplePlain,
    examplePrompt,
    id,
    title
  } = section;
  const panelId = `callie-capability-${id}`;
  const headerId = `${panelId}-header`;
  return <section className={capabilitySectionCss} data-testid={`callie-capability-${id}`}>
      <BareButton aria-controls={panelId} aria-expanded={isExpanded} className={capabilityHeaderCss} id={headerId} type="button" onClick={onToggle} onMouseDown={event => event.preventDefault()}>
        <div className={capabilityHeaderCopyCss}>
          <TitleText level="4" size="x-small">
            {title}
          </TitleText>
          <BodyText color="muted" size="medium">
            {description}
          </BodyText>
        </div>
        <span className={capabilityToggleCss}>
          {isExpanded ? <UiIcon icon={IconChevronDown} size="small" /> : <UiIcon icon={IconChevronRight} size="small" />}
        </span>
      </BareButton>
      <div aria-labelledby={headerId} className={capabilityContentCss} hidden={!isExpanded} id={panelId} role="region">
        {isExpanded && <CapabilityExample copySource={examplePlain} exampleLabel={exampleLabel} examplePrompt={examplePrompt} />}
      </div>
    </section>;
};
const buildCapabilitySections = () => [{
  id: 'share_availability',
  title: I18n.t('publisher.home.scheduling_subsection.callie.card.capabilities.share_availability.title'),
  description: I18n.t('publisher.home.scheduling_subsection.callie.card.capabilities.share_availability.description'),
  exampleLabel: I18n.t('publisher.home.scheduling_subsection.callie.card.example_label'),
  examplePrompt: I18n.t('publisher.home.scheduling_subsection.callie.card.capabilities.share_availability.example_prompt'),
  examplePlain: I18n.t('publisher.home.scheduling_subsection.callie.card.capabilities.share_availability.example_plain')
}, {
  id: 'book_meeting',
  title: I18n.t('publisher.home.scheduling_subsection.callie.card.capabilities.book_meeting.title'),
  description: I18n.t('publisher.home.scheduling_subsection.callie.card.capabilities.book_meeting.description'),
  exampleLabel: I18n.t('publisher.home.scheduling_subsection.callie.card.example_label'),
  examplePrompt: I18n.t('publisher.home.scheduling_subsection.callie.card.capabilities.book_meeting.example_prompt'),
  examplePlain: I18n.t('publisher.home.scheduling_subsection.callie.card.capabilities.book_meeting.example_plain')
}, {
  id: 'one_time_exception',
  title: I18n.t('publisher.home.scheduling_subsection.callie.card.capabilities.one_time_exception.title'),
  description: I18n.t('publisher.home.scheduling_subsection.callie.card.capabilities.one_time_exception.description'),
  exampleLabel: I18n.t('publisher.home.scheduling_subsection.callie.card.example_label'),
  examplePrompt: I18n.t('publisher.home.scheduling_subsection.callie.card.capabilities.one_time_exception.example_prompt'),
  examplePlain: I18n.t('publisher.home.scheduling_subsection.callie.card.capabilities.one_time_exception.example_plain')
}];
export const CallieCapabilitySections = ({
  expandedSectionId,
  onToggleSection
}) => {
  const capabilitySections = useMemo(buildCapabilitySections, []);
  return <div className={capabilitiesCss}>
      {capabilitySections.map(section => <CapabilitySection key={section.id} isExpanded={expandedSectionId === section.id} section={section} onToggle={() => onToggleSection(section.id)} />)}
    </div>;
};

require("./capability_sections.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./capability_sections.js");